module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.moduleType === 'show') ? _c('div', [_c('label', [_vm._v(_vm._s(_vm.label))]), _vm._v(" "), _c('p', [_c('span', [_vm._v("\n        " + _vm._s(_vm.localObject[_vm.localField.columnName]) + "\n      ")])])]) : _vm._e(), _vm._v(" "), (_vm.moduleType === 'list') ? _c('span', [_vm._v("\n    " + _vm._s(_vm.localObject[_vm.localField.columnName]) + "\n  ")]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-612bcf1b!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/utils/sgs/SgsRenderInputDataShowOrListWrapper.vue
// module id = 934
// module chunks = 2